module.exports = __webpack_public_path__ + "media/images/remittees_4_v2-6707e4afacb043330e363118b9e5e58e.jpg";